<template>
	<!-- data-error is used on the rma form, and scrollIntoView -->
	<div class="field" :class="{group}" :data-error="error">
		<div class="header">
			<div class="label">
				<div class="title" v-text="name"/>
				<div class="required" :class="{error}" v-if="required" v-text="'*'"/>
			</div>

			<div class="tooltip" v-if="tooltip" @mouseover="tooltipActive = true" @mouseleave="tooltipActive = false">
				<div class="icon" v-html="require('@/assets/icons/info-circle-solid.svg')"/>

				<transition name="box">
					<div class="box" v-if="tooltipActive">
						<div class="text" v-text="tooltip.text"/>
						<div class="img" v-if="tooltip.img"><img :src="tooltip.img"/></div>
						<div class="arrow">▼</div>
					</div>
				</transition>
			</div>
		</div>

		<slot/>

		<!-- <div class="msg" :class="{error}" v-if="test" v-text="test.msg"/> -->
	</div>
</template>

<script>
export default {
	props: {
		error: {type: Boolean, required: false},
		test: {type: Object, required: false},
		name: {type: String, required: false},
		group: {type: Boolean, required: false},
		tooltip: {type: Object, required: false},
		required: {type: Boolean, required: false}
	},
	data() {
		return {
			tooltipActive: false
		}
	}
};
</script>

<style lang="scss" scoped>
.field {
	width: calc(50% - 2em);
	margin-bottom: 32px;

	@include res(tablet) {
		width: calc(50% - 1em);
		margin-bottom: 22px;
	}

	@include res(mobile) {
		width: 100%;
	}

	&.group {
		width: 100%;
		margin: 2em 0 3em;
	}

	.header {
		display: flex;
		align-items: center;
		justify-content: space-between;

		.label {
			font-size: 12px;
			color: #4A4A4A;
			font-weight: 300;
			margin-bottom: 8px;
			display: flex;

			.required {
				font-size: 1.4em;
				margin-left: 0.2em;
				font-weight: 400;

				&.error {
					color: $red1;
				}
			}
		}

		.tooltip {
			margin-right: 0.5em;
			position: relative;

			.icon {
				/deep/ svg {
					$s: 16px;
					width: $s;
					height: $s;
					path {
						fill: #686880;
					}
				}
			}

			.box {
				background-color: $white1;
				box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.25);
				position: absolute;
				bottom: calc(100% + 1em);
				right: -2em;
				padding: 24px;
				width: 340px;
				display: flex;

				&-enter-active, &-leave-active {
					transition: cubic(opacity, 0.1s), cubic(transform, 0.1s);
				}
				&-enter, &-leave-to {
					opacity: 0;
					transform: translateY(2px);
				}

				.text {
					font-size: 12px;
					line-height: 18px;
					color: #182E38;
					font-weight: 300;
				}

				.img {
					width: 90px;
					flex-shrink: 0;
					margin-left: 24px;
				}

				.arrow {
					text-shadow: 1px 2px 4px rgba(0, 0, 0, 0.25);
					position: absolute;
					top: calc(100% - 3px);
					right: 2em;
					color: $white1;
				}
			}
		}
	}

	.msg {
		font-style: italic;
		font-size: 10px;
		font-weight: 300;
		color: grey;
		margin-top: 0.7em;

		&.error {
			color: $red1;
		}
	}
}
</style>
